export default "__VITE_ASSET__B0Xpx9L1__"